<div id="orders" class="page-layout carded fullwidth">

    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'FIRMWARE_LIST' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' |translate}}">
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="addFirmware()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->
        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="id"
                    matSortDirection="asc" fusePerfectScrollbar>

                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{firmware.id!=null?firmware.id:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- Model Column -->
                    <ng-container matColumnDef="model">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Model
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{(firmware?.model!=null)?firmware.model:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- Version Column -->
                    <ng-container matColumnDef="version">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'VERSION' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            <a   [routerLink]="['../../apps/firmware/packet']"
                                [queryParams]="{ firmwareId: firmware.id }">
                                {{firmware?.version==null?'---':firmware.version}}
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- FileName Column -->
                    <ng-container matColumnDef="fileName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FILE_NAME' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{firmware.fileName!=null?firmware.fileName:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- PacketSize Column -->
                    <ng-container matColumnDef="packetSize">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PACKET_COUNT' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{firmware.packetSize!=null?firmware.packetSize:'---' }}
                        </mat-cell>
                    </ng-container>

                    <!-- EndSize Column -->
                    <ng-container matColumnDef="endSize">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PACKET_SIZE' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{firmware.endSize!=null?firmware.endSize:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- update Column -->
                    <ng-container matColumnDef="uDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'UPDATED_DATE' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            {{firmware.uDate?(firmware.uDate | date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- setting Column -->
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let firmware">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button [routerLink]="['../../apps/firmware/packet']"
                                    [queryParams]="{ firmwareId: firmware.id }" mat-menu-item>
                                    <mat-icon>info</mat-icon>
                                    <span>{{'DETAIL' | translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteFirmware(firmware)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE' | translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let firmware; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>